<template>
  <div>
    <b-modal
      id="modal_register_box"
      ref="modal_register_box"
      modal-class="modal_register_box"
      header-class=""
      content-class="bg-transparent"
      body-class="p-0 bg-transparent"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-hidden="true"
      hide-footer
      hide-header
    >
      <button type="button" class="custom-close close position-absolute m-0 p-0" data-dismiss="modal" aria-label="Close" @click="$bvModal.hide('modal_register_box')">
        <i class="icon-clear" />
      </button>
      <template v-if="this.$store.state.brand.brandImage.register_modal_banner !== undefined">
        <div class="register-img">
          <img class="mw-100" :src="this.$store.state.brand.brandImage.register_modal_banner[0].image" alt="">
        </div>
      </template>
      <div class="custom-modal-body">
        <div class="modal_register_inner d-grid position-relative mb-20">
          <span>
            <h6 class="pb-10 mb-15">{{ $t("Bao.register") }}</h6>
            <div class="form-group mb-10">
              <div class="modal_register_block d-grid align-items-center">
                <label class="modal_register_title d-flex align-items-center mb-0" for="">
                  <svg class="mr-5" xmlns="http://www.w3.org/2000/svg" width="12" height="14.633" viewBox="0 0 12 14.633">
                    <g opacity="0.8">
                      <path d="M44.8,528.8c-3.313,0-6,2.263-6,5.056a1.864,1.864,0,0,0,2,1.685h8a1.863,1.863,0,0,0,2-1.685C50.8,531.064,48.113,528.8,44.8,528.8Z" transform="translate(-38.8 -520.908)" fill="#171B22" />
                      <path d="M269.4,13.679A3.679,3.679,0,1,0,273.079,10,3.678,3.678,0,0,0,269.4,13.679Z" transform="translate(-267.079 -10)" fill="#171B22" />
                    </g>
                  </svg>
                  <span>{{ $t("Bao.username") }}</span>
                </label>
                <input
                  v-model="postForm.username"
                  v-validate="'required'"
                  class="modal_register_ipt bg-white border-0"
                  type="text"
                  :placeholder="$t('Bao.member_username_limit')"
                  name="username"
                  :data-vv-as="$t('Bao.username')"
                  autocomplete="off"
                >
                <div v-if="errors.has('username')">&nbsp;</div>
                <small v-if="errors.has('username')" class="help-block">{{ errors.first('username') }}</small>
              </div>
            </div>
            <div class="form-group mb-10">
              <div class="modal_register_block d-grid align-items-center">
                <label class="modal_register_title d-flex align-items-center mb-0" for="">
                  <svg class="mr-5" xmlns="http://www.w3.org/2000/svg" width="12" height="14.667" viewBox="0 0 12 14.667">
                    <g opacity="0.8">
                      <path d="M102.433,16.667h5.334v-2a2.667,2.667,0,0,0-5.334,0v2Zm8.667,1v6a1,1,0,0,1-1,1h-10a1,1,0,0,1-1-1v-6a1,1,0,0,1,1-1h.334v-2a4.667,4.667,0,0,1,9.333,0v2h.334a1,1,0,0,1,1,1Z" transform="translate(-99.1 -10)" fill="#171B22" />
                    </g>
                  </svg>
                  <span>{{ $t("Bao.password") }}</span>
                </label>
                <input
                  v-model="postForm.newPassword"
                  v-validate="'required'"
                  class="modal_register_ipt bg-white border-0"
                  :placeholder="$t('Bao.password_notice')"
                  type="password"
                  name="newPassword"
                  :data-vv-as="$t('Bao.password')"
                  autocomplete="new-password"
                >
                <div v-if="errors.has('newPassword')">&nbsp;</div>
                <small v-if="errors.has('newPassword')" class="help-block">{{ errors.first('newPassword') }}</small>
              </div>
            </div>
            <div class="form-group mb-10">
              <div class="modal_register_block d-grid align-items-center">
                <label class="modal_register_title d-flex align-items-center mb-0" for="">
                  <svg class="mr-5" xmlns="http://www.w3.org/2000/svg" width="12" height="14.667" viewBox="0 0 12 14.667">
                    <g opacity="0.8">
                      <path d="M102.433,16.667h5.334v-2a2.667,2.667,0,0,0-5.334,0v2Zm8.667,1v6a1,1,0,0,1-1,1h-10a1,1,0,0,1-1-1v-6a1,1,0,0,1,1-1h.334v-2a4.667,4.667,0,0,1,9.333,0v2h.334a1,1,0,0,1,1,1Z" transform="translate(-99.1 -10)" fill="#171B22" />
                    </g>
                  </svg>
                  <span>{{ $t('Bao.confirmPassword') }}</span>
                </label>
                <input
                  v-model="postForm.confirmPassword"
                  v-validate="'required'"
                  class="modal_register_ipt bg-white border-0"
                  type="password"
                  name="confirmPassword"
                  :placeholder="$t('Bao.confirm_pass')"
                  :data-vv-as="$t('Bao.confirmPassword')"
                  autocomplete="off"
                >
                <div v-if="errors.has('confirmPassword')">&nbsp;</div>
                <small v-if="errors.has('confirmPassword')" class="help-block">{{ errors.first('confirmPassword') }}</small>
              </div>
            </div>
            <div v-if="$store.getters.permissionInfo.register_need_phone == 1" class="form-group mb-10">
              <div class="modal_register_block d-grid align-items-center">
                <label class="modal_register_title d-flex align-items-center mb-0" for="">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14.889" height="21" viewBox="0 0 15.889 22" style="padding-right:3px;">
                    <path d="M317.444,257h11a2.444,2.444,0,0,1,2.444,2.444v17.111A2.444,2.444,0,0,1,328.444,279h-11A2.444,2.444,0,0,1,315,276.556V259.444A2.444,2.444,0,0,1,317.444,257Zm.18,1.22h10.62a1.528,1.528,0,0,1,1.528,1.528v16.408a1.528,1.528,0,0,1-1.528,1.528h-10.62a1.528,1.528,0,0,1-1.528-1.528V259.748A1.528,1.528,0,0,1,317.625,258.22Zm5.32.613a.611.611,0,1,1-.611.611A.611.611,0,0,1,322.944,258.833Zm-6.679,1.681h13.4v.935h-13.4Zm0,14.647h13.4v.936h-13.4v-.935Z" transform="translate(-315 -257)" fill="#363636" fill-rule="evenodd" />
                  </svg>
                  <span>{{ $t('Bao.phone') }}</span>
                </label>
                <vue-tel-input
                  v-model="postForm.phone"
                  v-validate="'required'"
                  class="modal_register_ipt bg-white border-0"
                  :placeholder="$t('Bao.please_input')+$t('Bao.phone')"
                  name="phone"
                  :data-vv-as="$t('Bao.phone')"
                  :only-countries="countryList"
                  :default-country="defaultCountry"
                  mode="international"
                  :required="true"
                  autocomplete="off"
                />
                <div v-if="errors.has('phone')">&nbsp;</div>
                <small v-if="errors.has('phone')" class="help-block">{{ errors.first('phone') }}</small>
              </div>
            </div>
            <div v-if="$store.getters.permissionInfo.register_need_phone == 1" class="form-group mb-10">
              <div class="modal_register_block d-grid align-items-center custom_modal_register_block">
                <label class="modal_register_title d-flex align-items-center mb-0" for="">
                  <svg class="mr-5" xmlns="http://www.w3.org/2000/svg" width="12" height="14.667" viewBox="0 0 12 14.667">
                    <g opacity="0.8">
                      <path d="M102.433,16.667h5.334v-2a2.667,2.667,0,0,0-5.334,0v2Zm8.667,1v6a1,1,0,0,1-1,1h-10a1,1,0,0,1-1-1v-6a1,1,0,0,1,1-1h.334v-2a4.667,4.667,0,0,1,9.333,0v2h.334a1,1,0,0,1,1,1Z" transform="translate(-99.1 -10)" fill="#171B22" />
                    </g>
                  </svg>
                  <span>{{ $t('Bao.validateCode') }}</span>
                </label>
                <input
                  v-model="postForm.validateCode"
                  v-validate="'required'"
                  class="modal_register_ipt bg-white border-0"
                  :placeholder="$t('Bao.please_input')+$t('Bao.validateCode')"
                  type="text"
                  name="validateCode"
                  :data-vv-as="$t('Bao.validateCode')"
                >
                <button class="send-verify-btn bg-white d-flex align-items-center justify-content-center" @click="getCode">
                  <i v-show="gettingVerify" class="fa fa-spinner fa-pulse fa-fw" />
                  {{ limitVerify ? '(' + limitSecond + ')' : $t('Bao.get_verification_code') }}
                </button>
                <div v-if="errors.has('validateCode')">&nbsp;</div>
                <small v-if="errors.has('validateCode')" class="help-block">{{ errors.first('validateCode') }}</small>
              </div>
            </div>
            <div class="form-group mb-0">
              <div class="modal_register_block d-grid align-items-center">
                <label class="modal_register_title d-flex align-items-center mb-0" for="">
                  <svg class="mr-5" xmlns="http://www.w3.org/2000/svg" width="12" height="7.895" viewBox="0 0 12 7.895">
                    <g transform="translate(-0.122 -2.174)">
                      <path d="M11.489,10.069H.754a.631.631,0,0,1-.632-.631V7.227a1.264,1.264,0,0,0,0-2.527V2.807a.632.632,0,0,1,.632-.633H11.491a.632.632,0,0,1,.632.633V4.7a1.264,1.264,0,0,0,0,2.527v2.21a.634.634,0,0,1-.633.632Zm-.315-2.111a2.206,2.206,0,0,1,0-3.989V3.122H1.069v.847A2.207,2.207,0,0,1,2.332,5.964,2.2,2.2,0,0,1,1.069,7.958V9.122h10.1V7.958ZM8.332,5.017H3.911V4.07H8.332v.948Z" fill="#171B22" />
                    </g>
                  </svg>
                  <span>{{ $t('Bao.promotion_invite_code') }}</span>
                </label>
                <input
                  v-model="postForm.promotion_code"
                  v-validate="'numeric'"
                  class="modal_register_ipt bg-white border-0"
                  :placeholder="$t('Bao.please_leave_blank_if_none')"
                  type="text"
                  name="promotion_code"
                  :data-vv-as="$t('Bao.promotion_invite_code')"
                  :readonly="isCodeReadOnly"
                >
                <div v-if="errors.has('promotion_code')">&nbsp;</div>
                <small v-if="errors.has('promotion_code')" class="help-block">{{ errors.first('promotion_code') }}</small>
              </div>
            </div>
          </span>
          <div class="modal_register_ad">
            <template v-if="this.$store.state.brand.brandImage.register_modal_notion !== undefined">
              <ul class="modal_register_list d-grid justify-content-end list-unstyled mb-0">
                <li v-for="(item, key) in this.$store.state.brand.brandImage.register_modal_notion" :key="key">
                  <router-link :to="item.link">
                    <img class="mw-100" :src="item.image" alt="">
                  </router-link>
                </li>
              </ul>
            </template>
          </div>
        </div>
        <div class="d-flex justify-content-center checkbox_register">
          <label class="check">
            <span class="text">{{ $t("Bao.i_read_and_agree") }}《<span to="/page/privacy" @click="goMemberTerms()">{{ $t("Bao.member_terms") }}</span>》</span>
            <input v-model="agree" type="checkbox" @click="agree_error = false">
            <span class="checkmark" />
          </label>
        </div>
        <!-- <div class="d-flex justify-content-center agree-block">
          <input v-model="agree" type="checkbox" @click="agree_error = false">
          <span>{{ $t("Bao.i_read_and_agree") }}（<router-link to="/page/privacy">{{ $t("Bao.member_terms") }}</router-link>）</span>
        </div> -->
        <div class="d-flex justify-content-center agree-block mb-3">
          <small v-show="agree_error" class="help-block">{{ $t("Bao.have_to_agree_member_terms") }}</small>
        </div>
        <div class="d-flex justify-content-center">
          <button class="btn btn_free_register btn_register popup text-white border-0" type="button" :disabled="actionLoading" @click="clickRegister()">
            <b>{{ $t("Bao.sign_up_now") }}</b>
            <i v-show="actionLoading" class="fa fa-spinner fa-pulse fa-fw" />
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { getPhoneCode, register } from '@/api/user'
import { setErrorMessage, showNotice } from '@/utils/tool'
import { VueTelInput } from 'vue-tel-input'
import { login as localLogin } from '@/utils/user'

export default {
  components: {
    VueTelInput
  },
  data() {
    const postForm = {
      username: null,
      newPassword: null,
      confirmPassword: null,
      phone: null,
      validateCode: null,
      promotion_code: null,
      track_code: null,
      password: null
    }
    return {
      actionLoading: false,
      postForm,
      limitVerify: false,
      gettingVerify: false,
      isCodeReadOnly: false,
      countryList: [],
      agree: false,
      agree_error: false
    }
  },
  computed: {
    langImagePostfix: function() {
      const lang = this.$store.getters.language
      if (lang === 'zh' || lang === 'tw') {
        return 'zh'
      } else if (lang === 'vn') {
        return 'vn'
      } else {
        return 'en'
      }
    }
  },
  created() {
    if (this.$store.getters.inviteCode !== null) {
      this.postForm.promotion_code = this.$store.getters.inviteCode
      this.isCodeReadOnly = true
    }
    let url = (window.location.href || document.location.href).replace('&amp;', '&')
    url = url.replace('&amp%3B', '&')
    const trackCode = new URL(url).searchParams.get('trackCode')
    if (trackCode) {
      this.$store.commit('SET_TRACK_CODE', trackCode)
      this.postForm.track_code = trackCode
    }
    this.countryList = this.$store.getters.supportPhoneCode
    this.defaultCountry = this.countryList[0]
  },
  methods: {
    goMemberTerms() {
      this.agree_error = false
      this.$bvModal.hide('modal_register_box')
      this.$router.push('/page/terms')
    },
    getCode() {
      this.gettingVerify = true
      getPhoneCode({ phone: this.postForm.phone }).then(response => {
        showNotice(response.data.msg)
        this.countDown()
        this.gettingVerify = false
      }).catch((error) => {
        showNotice(error.response.data.msg)
        this.gettingVerify = false
      })
    },
    clickRegister() {
      if (!this.agree) {
        this.agree_error = true
        return
      }
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.actionLoading = true
          this.postForm.password = this.postForm.newPassword
          register(this.postForm).then(response => {
            showNotice(response.data.msg, () => {
              localLogin(response.data.data, null)
              this.$bvModal.hide('modal_register_box')
              this.$router.push('/event')
            })
          }).catch((error) => {
            setErrorMessage(error.response, this.errors)
          }).finally((e) => {
            this.actionLoading = false
          })
        }
      })
    }
  }
}
</script>

<style>
.modal_register_box .modal-dialog>img {
    border-radius: 10px 10px 0 0;
}
.custom-modal-body {
    position: relative;
    background-color: #f5f5f5;
    border-radius: 0 0 10px 10px;
    padding: 25px 45px 30px
}
.custom-close {
    right: -32px !important;
}

.modal_register_ipt .vti__input {
  color: #66696e;
}
.modal_register_ipt .vti__dropdown {
  padding: 0 0;
}

.modal_register_box .custom_modal_register_block {
  grid-template-columns: 90px 1fr 90px;
}

.send-verify-btn {
  color: #66696e;
  font-size: 12px;
  line-height: 1;
  border: 1px solid #d4d4d4;
  border-radius: 6px;
  padding: 8px 2px;
  margin-left: 6px;
  box-shadow: 0 4px 4px rgb(0 0 0 / 10%);
}

.agree-block {
  color: #66696e;
  font-size: 12px;
  line-height: 1;
}
</style>
